import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { fetchActivities, getActivitiesState } from '../../../../../store/slices/catalogSlice';
import AdvisorsGridPlaceholder from '../../../../icons/AdvisorsGridPlaceholder';
import ScrollIntersecting from '../../../ScrollIntersecting';
import Spinner from '../../../Spinner';
import CatalogCard from '../../CatalogCard';
import styles from './styles.module.scss';

const defaultImage = require('../../../../../resources/images/chat/defaultChatImg.jpg');

const ActivitiesList = ({ categoriesParams }) => {
    const { loading, list, reloading = false, currentPage, hasMore } = useSelector(getActivitiesState);
    const { t } = useTranslation();
    const dispatch = useDispatch();

    return (
        <>
            {loading && !!reloading && (
                <div className={styles.spinner}>
                    <Spinner />
                </div>
            )}
            {(!loading || !reloading) && !!list?.filter((item) => Boolean(item)).length ? (
                <div className={styles.wrapper}>
                    <ScrollIntersecting
                        hasMore={hasMore}
                        fetchFn={() => {
                            if (loading) {
                                return;
                            }
                            dispatch(fetchActivities({ categories: categoriesParams, page: currentPage, reloading: false }));
                        }}
                        isReadyForScroll={true}
                    >
                        {list.map((obj) => (
                            <CatalogCard
                                key={obj.id}
                                title={obj.title}
                                text={obj.description}
                                img={obj.image?.url || defaultImage}
                                advisorAlias={obj.id}
                                advisorId={obj.id}
                                isAllowMulti={false}
                                isActivities={true}
                            />
                        ))}
                    </ScrollIntersecting>
                </div>
            ) : (
                <div className={styles.empty}>
                    <AdvisorsGridPlaceholder />
                    <p>{t('labels.noAdvisor')}</p>
                </div>
            )}
        </>
    );
};

export default ActivitiesList;
